import { render, staticRenderFns } from "./TreeCategory.vue?vue&type=template&id=4ef67646&"
import script from "./TreeCategory.vue?vue&type=script&lang=js&"
export * from "./TreeCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports